import { InvoiceFormTypes } from "models/formTypes";
import { UtilsHelper } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useLastSavedMailOptions() {
  const updateSendMailOptionsFromLastSaved = (
    current: InvoiceFormTypes.SendMail,
    lastSaved?: WintSuperkollAPIModel.InvoiceSendProperties
  ) => {
    const result = { ...current };

    if (!lastSaved?.mailOptions) {
      return result;
    }

    const lastSavedMailOptions = lastSaved.mailOptions;

    const lastSavedTo = UtilsHelper.splitMultipleEmails(lastSavedMailOptions.to?.address ?? "");

    result.emailTo = lastSavedTo.map((email) => ({ id: email, value: email }));

    if (lastSavedMailOptions.from) {
      result.emailFrom = lastSavedMailOptions.from?.address;
      result.emailFromType = lastSavedMailOptions.from?.type;
    }

    if (lastSavedMailOptions.subject) {
      result.emailSubject = lastSavedMailOptions.subject;
    }

    if (lastSavedMailOptions.message) {
      result.emailMessage = lastSavedMailOptions.message;
    }

    return result;
  };

  return { updateSendMailOptionsFromLastSaved };
}

export default useLastSavedMailOptions;
